// © Microsoft Corporation. All rights reserved.
import React, { useState, useEffect, useRef } from 'react';
import { Label, Overlay, Stack, Spinner } from '@fluentui/react';
import Header from '../containers/Header';
import MediaGallery from '../containers/MediaGallery';
import { MediaFullScreen } from './MediaFullScreen';
import { CommandPanel, CommandPanelTypes } from './CommandPanel';
import { CommandPanelAll } from './CommandPanelAll';
import { Constants } from '../core/constants';
import {
  headerStyles,
  containerStyles,
  paneStyles,
  hiddenContainerClassName,
  activeContainerClassName,
  loadingStyle,
  overlayStyles,
  messageBarStyles,
  allpaneStyles
} from './styles/GroupCall.styles';
import {
  Call,
  LocalVideoStream,
  AudioDeviceInfo,
  VideoDeviceInfo,
  RemoteParticipant,
  CallAgent,
  DeviceManager,
  TeamsMeetingLinkLocator,
  GroupCallLocator,
  CallEndReason
} from '@azure/communication-calling';
import { ParticipantStream } from 'core/reducers/index.js';
import ComplianceBanner from '../containers/ComplianceBanner';
import { DialogBox } from './DialogBox';
import { ClientChatMessage } from '../core/reducers/MessagesReducer';
import { getMeetingUserDetails, saveChatMessages, leaveMeeting, saveAdditonalInfo } from '../core/chatSideEffects';
import { stopRecord } from '../core/sideEffects';
import {
  localStorageAvailable,
  getDisplayFirstNameFromLocalStorage,
  getDisplayLastNameFromLocalStorage,
  getDisplayEmailFromLocalStorage,
  saveDisplayIMOToLocalStorage,
  saveDisplayHEXIDToLocalStorage,
  saveDisplayMMSIToLocalStorage
} from '../Utils/localStorage';

export interface GroupCallProps {
  userId: string;
  groupId: string;
  call: Call;
  callAgent: CallAgent;
  callClient: any;
  deviceManager: DeviceManager;
  mic: boolean;
  remoteParticipants: any[];
  callState: string;
  localVideo: boolean;
  localVideoStream: LocalVideoStream;
  screenShareStreams: ParticipantStream[];
  audioDeviceInfo: AudioDeviceInfo;
  videoDeviceInfo: VideoDeviceInfo;
  audioDeviceList: AudioDeviceInfo[];
  videoDeviceList: VideoDeviceInfo[];
  screenWidth: number;
  shareScreen: boolean;
  callEndReason: CallEndReason;
  locator: GroupCallLocator | TeamsMeetingLinkLocator;
  isBeingRecorded: boolean;
  isBeingTranscribed: boolean;
  setAudioDeviceInfo(deviceInfo: AudioDeviceInfo): void;
  setVideoDeviceInfo(deviceInfo: VideoDeviceInfo): void;
  setLocalVideoStream(stream: LocalVideoStream | undefined): void;
  mute(): void;
  join(locator: GroupCallLocator | TeamsMeetingLinkLocator): void;
  endCallHandler(messages: any): void;
  recordingStatus: string;
  recordingError: string;
  dialogBoxVisiblilty(b: boolean): void;
  isDialogBoxVisiblile: boolean;
  darkColor: string;
  lightColor: string;
  onSendMessage(messageContent: string): void;
  displayName: string;
  messages: ClientChatMessage[];
  updateEmpCount(count: any): any;
  endCall(): void;
  endCallDisconnect(): void;
  setAddInfo(info: object): void;
  serverCallId: string;
}

export const GroupCall = (props: GroupCallProps): JSX.Element => {
  let intervalId: any = useRef(null)
  const spinnerLabel = 'Initializing call client...';
  const [selectedPane, setSelectedPane] = useState(CommandPanelTypes.None);
  const [selectedPaneDefault, setSelectedPaneDefault] = useState(true);
  const [selectedPanePeople, setSelectedPanePeople] = useState(true);
  const [selectedPaneSettings, setSelectedPaneSettings] = useState(true);
  const [selectedPaneAdd, setSelectedPaneAdd] = useState(true);
  const [timeCount, setCount] = useState(null);
  const [customersCount, setCustomersCount] = useState(0);
  const [employeesCount, setEmployeesCount] = useState(0);
  const [meetingEndTime, setMeetingEndTIme] = useState('');
  const [usersData, setParticipants] = useState([]);
  const activeScreenShare = props.screenShareStreams && props.screenShareStreams.length === 1;
  const defaultDisplayEmail = localStorageAvailable ? getDisplayEmailFromLocalStorage() : null;
  const defaultDisplayFirstName = localStorageAvailable ? getDisplayFirstNameFromLocalStorage() : null;
  const defaultDisplayLastName = localStorageAvailable ? getDisplayLastNameFromLocalStorage() : null;

  const { callAgent, call, join, locator, isBeingRecorded, isBeingTranscribed, callEndReason,
    remoteParticipants, serverCallId
  } = props;
  // console.log(serverCallId, 'serverCallId')
  useEffect(() => {
    if (callAgent && !call && callEndReason === undefined) {
      join(locator);
    }
  }, [callAgent, call, join, locator, callEndReason]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const meetingId = urlParams.get('meetingId');
    if (meetingId) {
      getMeetingInfoData();
    }
  }, [new URLSearchParams(window.location.search).get('meetingId')])

  let myInterval: any;
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const meetingId = urlParams.get('meetingId');
    if (meetingId) {
      const autoCallEndingAPIRunningTime: any = (sessionStorage.getItem('autoCallEndingAPIRunningTime') ? sessionStorage.getItem('autoCallEndingAPIRunningTime') : 60);
      //console.log(autoCallEndingAPIRunningTime, 'autoCallEndingAPIRunningTime')
      myInterval = setInterval(() => {
        const participants: any = remoteParticipants.map((participant) => {
          return {
            name: participant.displayName,
            userId: participant.userId
          };
        });
        participants.push({
          name: `${props.displayName}`,
          userId: `${props.userId}`
        });
        if (participants.length > 0) {
          setParticipants(participants);
          const urlParams = new URLSearchParams(window.location.search);
          const meetingId = urlParams.get('meetingId');
          if (meetingId) {
            getMeetingInfoData();
          }
        }
      }, Number(autoCallEndingAPIRunningTime) * 1000)
      return () => {
        clearInterval(myInterval);
      };
    }
  }, [new URLSearchParams(window.location.search).get('meetingId') || sessionStorage.getItem('autoCallEndingAPIRunningTime') || remoteParticipants])


  // useEffect(() => {
  //   if (remoteParticipants) {
  //     const participants: any = remoteParticipants.map((participant) => {
  //       return {
  //         name: participant.displayName,
  //         userId: participant.userId
  //       };
  //     });
  //     participants.push({
  //       name: `${props.displayName}`,
  //       userId: `${props.userId}`
  //     });
  //     if (participants.length > 0) {
  //       setParticipants(participants);
  //       const urlParams = new URLSearchParams(window.location.search);
  //       const meetingId = urlParams.get('meetingId');
  //       if (meetingId) {
  //         getMeetingInfoData();
  //       }
  //       const autoCallEndingAPIRunningTime: any = (sessionStorage.getItem('autoCallEndingAPIRunningTime') ? sessionStorage.getItem('autoCallEndingAPIRunningTime') : 60);
  //       // console.log(autoCallEndingAPIRunningTime * 1000)
  //       intervalId.current = setInterval(() => randomMagicNumber(), 60 * 1000);
  //     }
  //   }
  // }, [remoteParticipants]);

  // const randomMagicNumber = () => {
  //   console.log('call a function in every one minitue');
  //   getMeetingInfoData();
  // }

  const getMeetingInfoData = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const meetingId = urlParams.get('meetingId');
    const userInfo: any = await getMeetingUserDetails({ meetingId: meetingId, serverCallId: serverCallId });
    // console.log(userInfo, 'userInfo')
    if (userInfo && userInfo.data) {
      const userInfoData = userInfo.data;
      if (userInfoData && userInfoData.success) {
        // console.log(userInfoData, 'userInfoData')
        setCustomersCount(userInfoData.data.customersCount);
        // setEmployeesCount(userInfoData.data.employeeCount);
        setMeetingEndTIme(userInfoData.data.meetingEndTime);
        saveDisplayIMOToLocalStorage(userInfoData.data.imoNumber);
        saveDisplayHEXIDToLocalStorage(userInfoData.data.hexaNumber);
        saveDisplayMMSIToLocalStorage(userInfoData.data.mmsiNumber);
        props.setAddInfo({ imoNumber: userInfoData.data.imoNumber ? userInfoData.data.imoNumber : '', hexaNumber: userInfoData.data.hexaNumber ? userInfoData.data.hexaNumber : '', mmsiNumber: userInfoData.data.mmsiNumber ? userInfoData.data.mmsiNumber : '' });
        // if (userInfoData.data.customersCount > 0 && userInfoData.data.employeeCount === 0) {
        const totalCount = Number(userInfoData.data.customersCount) + Number(userInfoData.data.employeeCount)
        // console.log(totalCount, 'totalCount')
        props.updateEmpCount(totalCount);
        setEmployeesCount(totalCount)
        if (totalCount === 1) {
          // check the disconnect call function
          if (userInfoData.data.meetingEndTime) {
            var date1 = new Date();
            var date2 = new Date(userInfoData.data.meetingEndTime);
            var newDate = new Date(date2);
            newDate.setMinutes(date2.getMinutes() - date2.getTimezoneOffset());
            //console.log(date1.getHours(), date1.getMinutes(), newDate.getHours(), newDate.getMinutes())
            if (date1.getTime() > newDate.getTime()) {
              //console.log('auto disconnect a call');
              // props.endCall();
              saveComments(props.messages, totalCount);
              props.endCall();
              leaveMeeting(true, false);
              props.endCallDisconnect();
              return () => clearInterval(myInterval)
            }
          }
        }
        // else if (userInfoData.data.employeeCount > 0) {
        //   props.updateEmpCount(employeesCount);
        //   // console.log("clearInterval")
        //   // return () => clearInterval(myInterval)
        // }
      }
    }
  }

  useEffect(() => {
    if (employeesCount > 0) {
      // var offset = new Date().getTimezoneOffset();// getting offset to make time in gmt+0 zone (UTC) (for gmt+5 offset comes as -300 minutes)
      //   var date = new Date();
      //   date.setMinutes(date.getMinutes() + offset);// date now in UTC time
      //   var easternTimeOffset = -240; //for dayLight saving, Eastern time become 4 hours behind UTC thats why its offset is -4x60 = -240 minutes. So when Day light is not active the offset will be -300
      //   date.setMinutes(date.getMinutes() + easternTimeOffset);
      //   var converted = new Date(date).getFullYear() + '-' + ('0' + (new Date(date).getMonth() + 1)).slice(-2) + '-' + ('0' + new Date(date).getDate()).slice(-2) + ' ' + ('0' + new Date(date).getHours()).slice(-2) + ':' + ('0' + new Date(date).getMinutes()).slice(-2) + ':' + ('0' + new Date(date).getSeconds()).slice(-2);

      // saveAdditonalInfo('Call_Start_Time__c', new Date());
    }
  }, [employeesCount]);

  const dismissDialogBox = () => {
    props.dialogBoxVisiblilty(false);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleTabClosing)
    return () => {
      window.removeEventListener('beforeunload', handleTabClosing)
    }
  })

  const handleTabClosing = () => {
    saveComments(props.messages, employeesCount);
    props.endCall();
    leaveMeeting(true, false);
  }

  const saveComments = (messages: any, employeesCount: any) => {
    if (defaultDisplayEmail) {
      var splitMail = defaultDisplayEmail.split('@');
      if (splitMail.length == 2) {
        if (splitMail[1].toLowerCase() === 'liscr.com' || splitMail[1].toLowerCase() !== 'liscr.com') {
          var concatString = '';
          if (messages.length > 0) {
            messages.forEach((element: any) => {
              concatString += element.senderDisplayName + ': ' + element.content.message + '<br/>'
            });
          }
          var empCount: any = employeesCount;
          if (empCount === 1) {
            //saveChatMessages(concatString);
            stopRecord();
          }
        }
      }
    }
  }
  //console.log(selectedPane, 'selectedPane')

  // useEffect(() => {
  //   const checkMutedParticipants = () => {
  //     remoteParticipants.forEach((participant) => {
  //       if (participant.isSpeaking && participant.isMuted) {
  //         console.log('Unmute1', participant.identifier.communicationUserId, participant);
  //       }
  //       console.log('Unmute2', participant.identifier.communicationUserId, participant);
  //     });
  //   };

  //   const timerId = setInterval(checkMutedParticipants, 2000); // Check every 2 seconds

  //   return () => {
  //     clearInterval(timerId);
  //   };
  // }, [remoteParticipants]);

  return (
    <Stack styles={containerStyles}>
      <Stack.Item styles={headerStyles}>
        <Header
          selectedPane={selectedPane}
          setSelectedPane={setSelectedPane}
          endCallHandler={() => {
            props.endCallHandler(props.messages);
          }}
          screenWidth={props.screenWidth}
          groupId={props.groupId}
          setSelectedPaneDefault={setSelectedPaneDefault}
          darkColor={props.darkColor}
          lightColor={props.lightColor}
          employeesCount={employeesCount}
          connected={props.callState === Constants.CONNECTED}
        />
      </Stack.Item>
      {/* <Stack.Item styles={messageBarStyles}>
        <ComplianceBanner callTranscribeState={isBeingTranscribed} callRecordState={isBeingRecorded} />
      </Stack.Item> */}
      <Stack.Item styles={headerStyles}>
        {props.isDialogBoxVisiblile && props.recordingError !== '' && (
          <DialogBox
            message={props.recordingError}
            isDialogBoxVisiblile={props.isDialogBoxVisiblile}
            dismissDialogBox={dismissDialogBox}
          />
        )}
      </Stack.Item>
      <Stack.Item styles={containerStyles}>
        {props.shareScreen && (
          <div className={loadingStyle}>
            <Label>{defaultDisplayFirstName} {defaultDisplayLastName} screen is being shared</Label>
          </div>
        )}
        {(props.callState === Constants.CONNECTED) ? (
          <Stack horizontal styles={containerStyles}>
            <Stack.Item grow styles={activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>
              {activeScreenShare && <MediaFullScreen activeScreenShareStream={props.screenShareStreams[0]} />}
            </Stack.Item>
            <Stack.Item grow styles={!activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>
              <MediaGallery selectedPane={selectedPane} />
            </Stack.Item>
            {((window.innerWidth > Constants.MINI_HEADER_WINDOW_WIDTH) && (selectedPaneDefault) && (selectedPanePeople || selectedPaneSettings || selectedPaneAdd)) &&
              <Stack.Item disableShrink styles={allpaneStyles}>
                <CommandPanelAll {...props}
                  selectedPanePeople={selectedPanePeople}
                  selectedPaneSettings={selectedPaneSettings}
                  selectedPaneAdd={selectedPaneAdd}
                  setSelectedPanePeople={setSelectedPanePeople}
                  setSelectedPaneSettings={setSelectedPaneSettings}
                  setSelectedPaneAdd={setSelectedPaneAdd}
                />
              </Stack.Item>
            }
            {selectedPane !== CommandPanelTypes.None &&
              (window.innerWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? (
                <Stack.Item disableShrink styles={paneStyles}>
                  <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                </Stack.Item>
              ) : (
                <Overlay styles={overlayStyles} className='mob_chart_panel'>
                  <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                </Overlay>
              ))}
          </Stack>
        ) : (<Spinner label={spinnerLabel} ariaLive="assertive" labelPosition="top" style={{ marginTop: 100 }} />)}
        {props.callState === Constants.LOBBY && (
          <Stack horizontal styles={containerStyles}>
            <div className={loadingStyle} style={{ width: '100%' }}>
              <Label>Waiting to be admitted</Label>
            </div>
          </Stack>
        )}
      </Stack.Item>
    </Stack>
  );
};
